import { motion } from "framer-motion";

// Titolo che si rivela parola per parola allo scroll
export const TextReveal = ({ text, className = "", as = "h2", delay = 0, testId }) => {
  const Tag = motion[as] || motion.h2;
  const words = text.split(" ");
  return (
    <Tag
      className={className}
      data-testid={testId}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.4 }}
      transition={{ staggerChildren: 0.055, delayChildren: delay }}
    >
      {words.map((w, i) =>
        w === "|" ? (
          <br key={`br-${i}`} />
        ) : (
          <span key={`${w}-${i}`} className="inline-block overflow-hidden align-bottom">
            <motion.span
              className="inline-block"
              variants={{
                hidden: { y: "110%", opacity: 0 },
                visible: { y: "0%", opacity: 1 },
              }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              {w}
              {"\u00A0"}
            </motion.span>
          </span>
        )
      )}
    </Tag>
  );
};
